import { Button, InputNumber, List, Typography } from 'antd';
import { ListItem } from 'components';
import { useSessionPlayer } from 'hooks/traineeActions';
import React, { useEffect } from 'react';
import { BUYER, SELLER } from 'stateConstants';
import styled from 'styled-components';
import BuyerFinalOffer from './BuyerFinalOffer';
import SellerFinalOffer from './SellerFinalOffer';
import { Offer, Player } from 'types';

const { Paragraph, Text } = Typography;

const EliminationStep: React.FC<{
  player: Player;
  ownPerspective: boolean;
  data: Offer | Offer[];
}> = ({ player, ownPerspective, data }) => {
  // const { data: player, isLoading: isPlayerLoading } = useSessionPlayer();
  if (!player) return <Text>Player not found</Text>;
  return (
    <>
      {player.type === BUYER && (
        <BuyerFinalOffer
          offer={data as Offer}
          player={player}
          ownPerspective={ownPerspective}
        />
      )}
      {player.type === SELLER && (
        <SellerFinalOffer
          offers={data as Offer[]}
          player={player}
          ownPerspective={ownPerspective}
        />
      )}
    </>
  );
};

const Wrapper = styled.div`
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
`;

const Footer = styled.div`
  margin-top: 20px;
  display: flex;
  justify-content: right;
`;

export default EliminationStep;
